var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('h3', [_vm._v("CONNECTIONS")]), _vm._m(0), _vm.userNetworks && !_vm.selectedNetwork ? _c('div', {
    staticClass: "connection"
  }, [_c('div', {
    staticClass: "row pt-md-3 mt-md-3"
  }, _vm._l(_vm.socialPlatforms, function (socialPlatform, index) {
    return _c('section', {
      key: index,
      staticClass: "col-md-4 circle-info"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "alt": "",
        "src": ("" + (socialPlatform.logo))
      }
    }), _c('div', {
      staticClass: "text-center"
    }, [_vm.userNetworks.includes(socialPlatform.name) ? _c('button', {
      staticClass: "btn-universal btn-universal-social-disconnect",
      on: {
        "click": function ($event) {
          return _vm.btnSocialHandler(socialPlatform.name, 'rem');
        }
      }
    }, [_vm._v(" Disconnect ")]) : _c('button', {
      staticClass: "btn-universal",
      on: {
        "click": function ($event) {
          return _vm.btnSocialHandler(socialPlatform.name, 'add');
        }
      }
    }, [_vm._v(" Connect ")])])]);
  }), 0)]) : _vm._e(), _vm.selectedNetwork == 'xert' ? _c('xert-authentication', {
    on: {
      "connectionDone": _vm.onConnectionDone,
      "onCancel": _vm.onCancel
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "px-3 pt-2"
  }, [_vm._v(" Enjoy all the benefits of your favorite fitness apps by pairing them with MyWhoosh. To connect, you may be redirected to third-party apps. Please make sure to read their "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v(" Privacy Policy ")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_vm._v(" Terms & Conditions ")]), _vm._v(" ,as MyWhoosh isn't responsible for how your data is handled there. Once connected, your data syncs automatically—so you can spend less time managing and more time riding. ")]);
}]

export { render, staticRenderFns }